import React from 'react';
import { FolderTree, AlarmClock, Receipt } from 'lucide-react';

const CARDS = [
  {
    icon: FolderTree,
    title: 'Folder-name chaos',
    body:
      "Three folders named 'Aster', 'Aster Inc', and 'Aster Construction', all containing invoices from the same vendor. Typos, abbreviations, and whoever set up the folder structure five years ago. By the time anyone notices, there are thousands of files in the wrong place.",
  },
  {
    icon: AlarmClock,
    title: 'Multi-year payroll backlogs',
    body:
      "A bookkeeper inherits a OneDrive with a decade of board packets, pay stubs, and operations records scattered across nested year folders, with duplicates everywhere. Cleaning it up by hand is a six-month project nobody has time for. So it sits.",
  },
  {
    icon: Receipt,
    title: 'Invoice retrieval at tax time',
    body:
      "The accountant asks for every invoice from a specific vendor in Q3. You start clicking through Downloads, the shared OneDrive, and three Outlook attachments folders. An hour later you're still not sure you got them all. Files exist. Finding them is the job.",
  },
];

const PainPoints = () => {
  return (
    <section id="problem" className="my-20">
      <div className="text-center mb-14">
        <h2 className="text-3xl sm:text-4xl font-semibold mb-4 tracking-tight text-apple-50">
          The Filing Problem
        </h2>
        <p className="text-apple-300 text-lg font-light max-w-2xl mx-auto">
          Three patterns we hear from bookkeepers at construction firms, trucking companies, and
          municipal service districts.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {CARDS.map((card, i) => {
          const Icon = card.icon;
          return (
            <div
              key={i}
              className="bg-apple-800/40 backdrop-blur-sm rounded-2xl border border-apple-700/50 p-6"
            >
              <div className="w-10 h-10 rounded-full bg-sortio-secondary/15 border border-sortio-secondary/30 flex items-center justify-center mb-4">
                <Icon className="text-sortio-secondary" size={18} />
              </div>
              <h3 className="text-lg font-medium text-apple-50 mb-3">{card.title}</h3>
              <p className="text-sm text-apple-200 leading-relaxed">{card.body}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default PainPoints;
